import { createSelector } from 'reselect'
import { getLeAccommodationItems } from '../view/accommodation'

const getCheckoutItemsWithLoyaltyUpgradeApplied = createSelector(
  (state: App.State) => getLeAccommodationItems(state),
  (leAccommodationItems) => {
    return leAccommodationItems.filter(item => item.loyaltyAppliedUpgradeType)
  },
)

export default getCheckoutItemsWithLoyaltyUpgradeApplied
